module.exports = __webpack_public_path__ + "static/media/Triangle.3b74f5fc.svg";